import React, { FunctionComponent } from 'react';
import { MediaBreakpoint, useBreakpointInfo } from '../../../../hooks/useDeviceInfo';
import { CTAPanel } from '../../../shared/CTAPanel';
import { useTranslations } from '../../../../hooks/useTranslationsHelper';
import { useBrandedNavigate } from '../../../../hooks/useBrandedNavigate';

export const GameInfoRegBonus: FunctionComponent = () => {
  const { t } = useTranslations();
  const isBelowMobileWidth = useBreakpointInfo([MediaBreakpoint.BELOW_MOBILE]);
  const colorCTAPanel = 'var(--cta-panel-background-color)';
  const { registrationUrl } = useBrandedNavigate();

  return (
    <CTAPanel
      ctaButtonSize={isBelowMobileWidth ? 'medium' : 'large'}
      background={colorCTAPanel}
      heading={t('betzone.welcome')}
      ctaURL={registrationUrl}
      ctaLabel={t('buttons.join-here.uppercase')}
    >
      {t('betzone.bonus-description')}
    </CTAPanel>
  );
};
